import React from "react";
import Footer from "../../Footer/Footer";
// import "../style/style-2.6.0.css";
import NavBar1 from "../../Navbar1/NavBar1";
export default function PrivacyPolicy() {
  return (
    <>
      <Footer>
        <NavBar1 />
        <main id="main">
          <div class="container">
            <div class="page-header">
              <h1 class="page-title">Privacy Policy</h1>
            </div>
            <div class="page-content">
              <h3>
                IF YOU DO NOT AGREE, PLEASE DO NOT USE OR ACCESS THE WEBSITE.
              </h3>
              We are committed to protecting the privacy and security of the
              users of our Sites. This Privacy Policy will advise you about our
              guidelines concerning the use of your personal information,
              including, but not limited to, the reasonable efforts we make to
              protect your personal information in accord with these guidelines,
              and about what choices you have concerning our use of such
              information. Please read this policy carefully. We may update this
              policy from time to time in order to address new issues and
              reflect changes on our sites. We will post those changes here.
              Please refer back to this policy regularly. If you have any
              questions or concerns about our Privacy Policy, please send an
              e-mail to: care@k5fitness.in We highly value your privacy and make
              this policy easily available throughout our site to assist you in
              understanding the handling of information in the course of using
              this site.
              <h3>LINKING TO THIS WEBSITE</h3>
              <p>
                Creating or maintaining any link from another Website to any
                page on this Website without our prior written permission is
                prohibited. Running or displaying this Website or any
                information or material displayed on this Website in frames or
                through similar means on another Website without our prior
                written permission is prohibited. Any permitted links to this
                Website must comply will all applicable laws, rule and
                regulations.
              </p>
              <h3>LINKS TO OTHER WEBSITES</h3>
              <p>
                This website may contain links to other sites that are not
                controlled in any way by us. Please be aware of this when you
                click on any such links; we are not responsible for the privacy
                practices and/or policies of any website other than our own.
                Consequently, we strongly suggest that you review the privacy
                policy of every website you visit, whether or not they are
                linked to by our own site.
              </p>
              <h3>REGISTRATION AND USE OF PERSONAL INFORMATION</h3>
              <p>
                If you give us your permission, we may also use personal
                identification information for internal or external marketing
                and promotional purposes. On occasion, for example, we may send
                you e-mails to introduce a product or a service that we think
                might be of interest to the users of our Sites. For us to obtain
                your permission to send you this information, we will give you
                an opportunity to "opt-in" at the time our request for your
                personal information is made. If you do "opt-in," you may choose
                to "opt-out" at any time, even after you have provided personal
                information, by following the procedures set forth below at the
                end of this Privacy Policy. Please note, however, that under
                certain circumstances, if you initially do not choose to
                "opt-in," or if you later "opt-out," you may not be eligible for
                certain benefits for which a name, e-mail address, telephone
                number or other personal identification information is needed.
                We also provide visitors to our website the opportunity to
                opt-in to receive communications from us. In this case, we ask
                the visitor for his or her email address. These communications
                may include a regular newsletter, product promotions, voluntary
                promotions or contests, and any other information that we feel
                may be pertinent to the visitor. You may opt out of receiving
                any, or all, of these communications by emailing your request to
                contact@k5fitness.in, by clicking on the “Unsubscribe” link in
                any email we send to you, or by replying to any email we send
                you and entering the word UNSUBSCRIBE in the subject line.
                Again, if you provide us with your email address and/or name for
                the purposes of receiving communications from us, this
                information will not be shared with any third-party
                organization.
              </p>
              <h3>ACCESS TO PERSONALLY IDENTIFIABLE INFORMATION</h3>
              <p>
                If your personally identifiable information changes, or if you
                no longer wish us to possess your information, you may request
                correction, updating, or deletion of your information by
                emailing us at contact@k5fitness.in. You may also make your
                request by phone or postal mail at the address/phone number
                indicated at the end of this Privacy Policy.
              </p>
              <h3>NON-PERSONAL IDENTIFICATION INFORMATION</h3>
              <p>
                This website utilizes industry standard analytics packages which
                gathers limited information on visitors to our website
                automatically, and stores this anonymous information in server
                log files. This information may include IP addresses, browser
                type, basic IP information, referring pages, operating system
                used and date/time stamps. This information does not identify
                individual users; it is used only for site administration, as
                well as for analysis of website usage and trends. Additionally,
                cookies may be used to provide easier and faster access to
                website features such as logins and/or repeat visits. Cookies
                are very small text files that are stored on personal computers
                for reference purposes. We do not link the information we store
                in cookies to any personally identifiable information you have
                submitted while on our site.
              </p>
              <p>
                We use both session ID cookies and persistent cookies. A session
                cookie expires when your browser is closed, and a persistent
                cookie may stay on your hard drive for an extended period.
                Session cookies make it easier for you to navigate our site;
                persistent cookies can perform such activities as storing your
                password for forums or blogs so you do not have to sign in every
                time you visit those areas, and/or may be used to enable us to
                track and target the interests of our users so as to enhance the
                overall experience of using our site.
              </p>
              <p>
                We have no access to or administration abilities over any
                cookies that are used by any advertisers on our site.
              </p>
              <h3>SECURITY</h3>
              <p>
                Protecting your privacy and information is a top priority. We
                follow accepted industry standards to protect any personal
                information you have provided to us. However, please be aware
                that no method of electronic storage can ever be 100% secure.
                Therefore - as is the case with any organization - we are not in
                a position to guarantee the absolute security of your
                information. You may submit any questions you may have about our
                security procedures by emailing us at contact@k5fitness.in.{" "}
              </p>
              <h3>SITE ACTIVITY TRACKING</h3>
              <p>
                So that we can gain insight on how people are using our
                website(s), as well as to gain information or perform functions
                beneficial to users of our website(s) or to our organization, we
                may track the activity of visitors over time using the
                website(s) / web server(s), as well as one or more third party
                service(s). Our website(s) do not currently recognize
                browser-based "do not track" functionality, but the privacy of
                our users is important to us and, as such, we do not sell your
                personally-identifiable information to any third party, nor do
                we track users' activity across website(s) other than our own.
                There may be third party embedded items on our website(s) such
                as video players, social features, or otherwise. The
                organizations providing these third party items have the ability
                to track users that view pages containing those items, but they
                can only receive limited data by virtue of being viewed on our
                website(s) such as IP address and technical details about your
                computer / browser / internet connection. If you or a third
                party has provided personal information to one of these
                organizations in the past, they may be able to associate your
                activity with that information. For more details or to find out
                how to control your privacy settings with a third party
                provider, please visit their respective website.
              </p>
              <h3>LEGAL DISCLAIMER</h3>
              <p>
                We reserve the right to disclose your personally identifiable
                information as required by law and when we believe that
                disclosure is necessary to protect our rights and/or to comply
                with a judicial proceeding, court order, or legal process served
                on our website.
              </p>
              <h3>YOUR ACCEPTANCE OF THESE TERMS</h3>
              <p>
                By using any of the Sites, you signify your acceptance of our
                Privacy Policy, your promise to comply with the representations
                you make and contained in the Privacy Policy and Terms and
                Conditions, and your understanding of the scope and limitations
                of the protections provided under the Privacy Policy and Terms
                and Conditions. If you do not agree to these policies, please do
                not use our Sites. Your continued use of the Sites following the
                posting of changes to these terms.
              </p>
              <h3>
                CONDITIONS OF USE- IMPORTANT LEGAL INFORMATION USE OF THIS
                WEBSITE
              </h3>
              <p>
                Stance Website and all of its materials, including, but not
                limited to, its software or HTML code, scripts, text, artwork,
                photographs, images, video, and audio (collectively, "Materials"
                ) are protected by copyright laws and other U.S. and
                international laws and treaties. All Materials are provided by
                Stance as a service to its current and prospective store owners
                and customers and may be used only for personal informational
                and product ordering purposes and only if you also retain all
                copyright and other proprietary notices contained on the
                Materials. No right, title or interest in our Materials is
                conveyed to you this is a limited license, not a transfer of
                title to our Materials, and such license is subject to the
                following restrictions: (a) you may not copy, reproduce,
                publish, transmit, distribute, perform, display, post, modify,
                create derivative works from, sell, license or otherwise exploit
                this site or any of its Materials without our prior written
                permission; (b) you may not access or use the Stance for any
                competitive or commercial purpose; and (c) you will not permit
                any copying of our Materials. Any unauthorized copying,
                alteration, distribution, transmission, performance, display, or
                other use of these Materials is prohibited.
              </p>
              <h3>TRADEMARKS</h3>
              <p>
                Certain trademarks, trade names, service marks and logos used or
                displayed on this Website are registered and unregistered
                trademarks, trade names and service marks of STANCE and its
                affiliates. Other trademarks, trade names and service marks used
                or displayed on this Website are the registered and unregistered
                trademarks, trade names and service marks of their respective
                owners, including STANCE and its affiliates. Nothing contained
                on this Website grants or should be construed as granting, by
                implication, or otherwise, any license or right to use any
                trademarks, trade names, service marks or logos displayed on
                this Website without the written permission of STANCE, or such
                other owner. DISCLAIMERS. YOUR USE OF THIS SITE IS AT YOUR RISK.
                THE INFORMATION, NEITHER STANCE, NOR ANY OF THEIR RESPECTIVE
                AFFILIATES WARRANT THE ACCURACY OR COMPLETENESS OF THE
                INFORMATION, MATERIALS OR SERVICES PROVIDED ON OR THROUGH THIS
                WEBSITE. THE INFORMATION, MATERIALS AND SERVICES PROVIDED ON OR
                THROUGH THIS WEBSITE MAY BE OUT OF DATE, AND NEITHER STANCE, NOR
                ANY OF THEIR RESPECTIVE AFFILIATES MAKES ANY COMMITMENT OR
                ASSUMES ANY DUTY TO UPDATE SUCH INFORMATION, MATERIALS OR
                SERVICES.
              </p>
              <h3>LIMITATIONS OF LIABILITY</h3>
              <p>
                Neither STANCE assumes any responsibility, or will be liable,
                for any damages to, or any viruses that may infect, your
                computer, telecommunication equipment, or other property caused
                by or arising from your access to, use of, or browsing this
                Website, or your downloading of any information or materials
                from this Website. IN NO EVENT WILL STANCE, OR ANY OF THEIR
                RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, SHAREHOLDERS,
                AFFILIATES, AGENTS, SUCCESSORS OR ASSIGNS, NOR ANY PARTY
                INVOLVED IN THE CREATION, PRODUCTION OR TRANSMISSION OF THIS
                WEBSITE, BE LIABLE TO YOU OR ANYONE ELSE FOR ANY DIRECT,
                INDIRECT, SPECIAL, PUNITIVE, INCIDENTAL OR CONSEQUENTIAL DAMAGES
                (INCLUDING, WITHOUT LIMITATION, THOSE RESULTING FROM LOST
                PROFITS, LOST DATA OR BUSINESS INTERRUPTION) ARISING OUT OF THE
                USE, INABILITY TO USE, OR THE RESULTS OF USE OF THIS WEBSITE,
                ANY WEBSITES LINKED TO THIS WEBSITE, OR THE MATERIALS,
                INFORMATION OR SERVICES CONTAINED ON ANY OR ALL SUCH WEBSITES,
                WHETHER BASED ON WARRANTY, CONTRACT, TORT OR ANY OTHER LEGAL
                THEORY AND WHETHER OR NOT ADVISED OF THE POSSIBILITY OF SUCH
                DAMAGES. THE FOREGOING LIMITATIONS OF LIABILITY DO NOT APPLY TO
                THE EXTENT PROHIBITED BY LAW. PLEASE REFER TO YOUR LOCAL LAWS
                FOR ANY SUCH PROHIBITIONS.
              </p>
              <p>
                IN THE EVENT OF ANY PROBLEM WITH THIS WEBSITE OR ANY CONTENT,
                YOU AGREE THAT YOUR SOLE REMEDY IS TO CEASE USING THIS WEBSITE.
              </p>
              <h3>Revisions to the Conditions of Use</h3>
              <p>
                The Conditions of Use may be revised at any time and from time
                to time by updating this posting. You should visit this page
                from time to time to review the then current Conditions of Use
                because they are binding on you. Certain provisions of the
                Conditions of Use may be superseded by legal notices or terms
                located on particular pages of this Website.
              </p>
              <h3>HEALTH RELATED INFORMATION</h3>
              <p>
                The information contained in the Website is provided for
                informational purposes only and is not meant to substitute for
                the advice provided by your doctor or other health care
                professional. You should not use the information available on or
                through the Website (including, but not limited to, information
                that may be provided on the Website by healthcare or nutrition
                professionals employed by or contracting with STANCE) for
                diagnosing or treating a health problem or disease, or
                prescribing any medication. Information and statements regarding
                dietary supplements have not been evaluated by the Food Safety
                and Standards Authority of India and are not intended to
                diagnose, treat, cure, or prevent any disease. You should read
                carefully all product packaging prior to use.
              </p>
              <h3>INDEMNITY</h3>
              <p>
                You agree to indemnify and hold STANCE, and affiliates (and
                their licensees), and subsidiaries, officers, directors,
                employees, successors and assigns, harmless from any claim, loss
                or demand, including reasonable attorneys' fees, made by any
                third party due to or arising out of your use of our Website,
                your connection to our Website, your violation of these Terms
                and Conditions, or your violation of any rights of another
                party. This indemnity survives termination of these Conditions
                of Use. Google AdWords and Facebook Remarketing We use Google
                AdWords re-marketing technology to market our sites across the
                Internet. We place a cookie on your browser, and then a 3rd
                party (Google) reads these cookies and may serve an ad on a 3rd
                party site, after you have visited our website. If you do not
                want information collected through the use of cookies, there is
                a simple procedure in most browsers that allows a customer to
                deny or accept the cookie feature; however, you should note that
                cookies may be necessary to provide customers with certain
                features (e.g., customised delivery of information) available on
                this website. You may opt out of this ad serving on Google’s opt
                out page HERE. You may opt out of this ad serving on Facebook’s
                opt out page HERE.
              </p>
              <h3>YOUR ACCEPTANCE OF THESE TERMS</h3>
              <p>
                By using any of the Sites, you signify your acceptance of our
                Privacy Policy, your promise to comply with the representations
                you make and contained in the Privacy Policy and Terms and
                Conditions, and your understanding of the scope and limitations
                of the protections provided under the Privacy Policy and
                Conditions of Use. If you do not agree to these policies, please
                do not use our Sites. Your continued use of the Sites following
                the posting of changes to these terms.{" "}
              </p>
              <h3>SMS Terms & Conditions:</h3>
              <p>
                Opt into SMS marketing and notifications occur by entering your
                phone number in the checkout page and initializing a purchase,
                subscribing via a subscription form, or texting a keyword. By
                opting into SMS marketing notifications, you agree to the
                following terms and conditions: You understand and agree that
                consent is not a condition for any purchase. You understand and
                agree that your phone number, name, and purchase information
                will be shared with our SMS marketing platform Consistent Cart,
                created by CartKit Inc, a company with an office at Atlanta, GA,
                USA. You understand and agree that data collected will be used
                for sending you notifications (such as abandoned cart reminders)
                and targeted marketing messages. Upon sending the SMS messages,
                your phone number will be passed to our SMS delivery partner to
                fulfill the delivery of the message. You understand and agree
                that if you wish to unsubscribe from receiving further SMS
                marketing messages and notifications reply with STOP to any
                message sent from us. You understand and agree that other
                methods of opting out, such as using alternative words will not
                be a reasonable means of opting out. You understand and agree
                that message and data rates may apply when receiving SMS
                messages.
              </p>
              <h3>Contact information</h3>
              <p>
                If you have questions, you can contact us at:
                contact@k5fitness.in
              </p>
            </div>
          </div>
        </main>
      </Footer>
    </>
  );
}
